import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'borderRadius',
})(({ theme, borderRadius }) => ({
  '& .MuiDialog-paper': {
    borderRadius: borderRadius || theme.shape.borderRadius * 2,
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const PortalDialog = ({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = 'sm',
  fullWidth = true,
  sx,
  showCloseButton = true,
  titleSx,
  closeSx,
  borderRadius = 12,
}) => {
  return (
    <BootstrapDialog
      onClose={onClose}
      aria-labelledby="portal-dialog-title"
      open={open}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={sx}
      borderRadius={borderRadius}
    >
      <DialogTitle sx={titleSx ?? { ml: 3, p: 3 }} id="portal-dialog-title">
        {title}
        {showCloseButton && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 16,
              top: 16,
              color: theme.palette.grey[500],
              ...closeSx,
            })}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </BootstrapDialog>
  );
};

export default PortalDialog;
